﻿import React, { useState } from "react";
import PrivacyDrawer from "./privacyDrawer/PrivacyDrawer";
import Content from "./content/Content";
import { useStateLocalStorage } from "@dotlegal/dotlegal-ui-components";
import { Box } from "@mui/material";
import { useTrialInformationHook } from "../trial/TrialInformation.hooks";
import { AiChatProvider } from "../aiChat/AiChatContext";
import AiChat from "../aiChat/AiChat";
import PaneHost from "./panes/PaneHost";
import RailSpacer from "./rail/RailSpacer";

export interface IMainProps {
    children: JSX.Element;
}

function Main(props: IMainProps) {
    const [isExpandedBigScreen, setIsExpandedBigScreen] = useStateLocalStorage("menu-expanded", true);
    const [isExpandedSmallScreen, setIsExpandedSmallScreen] = useState(false);
    const { data } = useTrialInformationHook();

    return (
        <AiChatProvider>
            <Box
                sx={(theme) => ({
                    backgroundColor: "white",
                    display: "flex",
                    [theme.breakpoints.down("md")]: {
                        flexDirection: "column",
                    },
                    [theme.breakpoints.up("md")]: {
                        flexDirection: "row",
                    },
                    minHeight: "100vh",
                })}
            >
                <PrivacyDrawer
                    ribbonShown={data?.hasAlmostExpiredTrials ?? false}
                    isExpandedBigScreen={isExpandedBigScreen}
                    isExpandedSmallScreen={isExpandedSmallScreen}
                    setIsExpandedBigScreen={setIsExpandedBigScreen}
                    setIsExpandedSmallScreen={setIsExpandedSmallScreen}
                />

                <Content>{props.children}</Content>

                <RailSpacer />
                <AiChat />
                <PaneHost />
            </Box>
        </AiChatProvider>
    );
}

export default Main;
